var React = require('react');

function TwitterIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"currentColor","d":"M15 .04c8.285 0 15 6.717 15 15 0 8.285-6.715 15-15 15-8.284 0-15-6.715-15-15 0-8.283 6.716-15 15-15m7.548 11.976a7.68 7.68 0 0 0 1.885-1.957c-.677.3-1.406.504-2.17.596a3.794 3.794 0 0 0 1.662-2.092c-.73.433-1.54.748-2.4.917a3.78 3.78 0 0 0-6.438 3.448A10.724 10.724 0 0 1 7.3 8.978a3.782 3.782 0 0 0 1.17 5.048 3.764 3.764 0 0 1-1.712-.474v.05a3.783 3.783 0 0 0 3.03 3.705 3.771 3.771 0 0 1-1.706.065 3.783 3.783 0 0 0 3.53 2.625 7.58 7.58 0 0 1-4.693 1.618c-.305 0-.605-.017-.9-.052a10.687 10.687 0 0 0 5.79 1.698c6.95 0 10.75-5.76 10.75-10.756 0-.164-.002-.326-.01-.489"}))));
}

TwitterIcon.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = TwitterIcon;

TwitterIcon.default = TwitterIcon;
